// extracted by mini-css-extract-plugin
module.exports = {"primary":"#7896c5","tablet":"769px"};